import { Grid, Stack, IconButton, InputAdornment, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';

import ApiService, { isInfossNo } from '../../../../../services/ApiService';
import SelectDataContact from '../Selects/SelectDataContact';
import SelectDataCOA from '../Selects/SelectDataCOA';
import { CustomDatePicker, Icon, Input, Selection, showToast, TickBox } from '../../../../../components/ui';
import { convertToNominal } from '../../../../../utils/masks.jsx';
import { setDateFormat, updateDateFormat } from '../../../../../utils/date';

const DownPaymentHeader = (props) => {
    const PaymentByData = [
        { id: 1, code: 2, name: 'Shipper' },
        { id: 2, code: 3, name: 'Consignee' }
    ];

    const BasedOnJobData = [
        { id: 1, code: true, name: 'Yes' },
        { id: 2, code: false, name: 'No' }
    ];

    const [titleModal, setTitleModal] = useState('');
    const [isModal, setIsModal] = useState(false);

    const paramC = "regContact/regContact";
    const [isLoadingC, setIsLoadingC] = useState(false);
    const [dataC, setDataC] = useState([]);
    const [dataMapC, setDataMapC] = useState([])
    const [columnDataC, setColumnDataC] = useState([])
    const [SelectedDataC, setSelectedDataC] = useState({});
    const [totalRowsC, setTotalRowsC] = useState(50);

    const handleClick = () => {
        if (isModal === false) {
            setIsModal(true);
            getDataContact(1, 50);
        }
        else {
            setIsModal(false);
        }
    };

    const searchCustomer = (data) => {
        if (data === 'search') {
            if (props.JobOwnerId !== 0) {
                setTitleModal('Customer');
                handleClick();
            }
            else {
                showToast({ type: 'error', message: 'Please Select Principle By First!' });
            }
        }
        else if (data === 'delete') {
            props.setCustomerId(0);
            props.setCustomerCode('');
            props.setCustomerName('');

            props.setShipmentOrderList([]);
            props.setShipmentOrderIdList([]);
            props.setSelectedShipmentOrder({});
            props.setBankData([]);
            props.setCashPaymentUSD(0);
            props.setCashPaymentIDR(0);
            props.calculateTotalBank([], props.isDPJob);
            props.calculateTotalCash([]);

            props.setTotalCashUSDReal(0);
            props.setTotalCashIDRReal(0);

            let formatUSD = convertToNominal(0);
            let formatIDR = convertToNominal(0);
            props.setTotalCashUSD(formatUSD);
            props.setTotalCashIDR(formatIDR);
        }
    }

    const [titleModal2, setTitleModal2] = useState('');
    const [isModal2, setIsModal2] = useState(false);

    const paramO = "regChartOfAccountEntry/regChartOfAccountEntry";
    const [isLoadingO, setIsLoadingO] = useState(false);
    const [dataO, setDataO] = useState([]);
    const [dataMapO, setDataMapO] = useState([]);
    const [columnDataO, setColumnDataO] = useState([]);
    const [SelectedDataO, setSelectedDataO] = useState({});
    const [totalRowsO, setTotalRowsO] = useState(50);

    const handleClick2 = () => {
        if (isModal2 === false) {
            setIsModal2(true);
            getDataCOA(1, 50);
        }
        else {
            setIsModal2(false);
        }
    };

    const searchReceiptType = (data) => {
        if (data === 'search') {
            setTitleModal2('Chart Of Account (COA)');
            handleClick2();
        }
        else if (data === 'delete') {
            props.setCOACode('');
            props.setCOAName('');
        }
    };

    const getDataContact = (pageNumber, pageSize, filters) => {
        setIsLoadingC(true);
        let params = [];
        params = [
            ...params,
            { 'attr': 'contactTypeId', 'value': '' + props.CustomerTypeId }
        ]
        ApiService.DynamicPostByPage(paramC, 'SEARCH', pageNumber, pageSize, params, filters)
            .then((response) => {
                if (response.data.code === 200) {
                    setSelectedDataC({})
                    setDataC(response.data.data.contact);

                    let temp = response.data.data.contact
                    let indexed = temp.map((el, index) => {
                        let indexedTemp = {
                            ...el,
                            index
                        }
                        return indexedTemp
                    })

                    setDataMapC(indexed)
                    setColumnDataC(response.data.data.columns)
                    setTotalRowsC(response.data.totalRowCount)

                    setIsLoadingC(false)
                }
                setIsLoadingC(false)
            })
            .catch(function (error) {
                setIsLoadingC(false)
                console.error('error saat fetch', error)
                showToast({ type: 'error', message: error.toString() });
            })
    };

    const getDataCOA = (pageNumber, pageSize, filters) => {
        setIsLoadingO(true);
        let params = [
            {
                'attr': 'entryFor',
                'value': 'DP'
            }
        ]
        ApiService.DynamicPostByPage(paramO, 'SEARCH', pageNumber, pageSize, params, filters)
            .then((response) => {
                if (response.data.code === 200) {
                    setSelectedDataO({})
                    setDataO(response.data.data.chartOfAccountEntry);

                    let temp = response.data.data.chartOfAccountEntry
                    let indexed = temp.map((el, index) => {
                        let indexedTemp = {
                            ...el,
                            index
                        }
                        return indexedTemp
                    })

                    setDataMapO(indexed)
                    setColumnDataO(response.data.data.columns)
                    setTotalRowsO(response.data.totalRowCount)

                    setIsLoadingO(false)
                }
                setIsLoadingO(false)
            })
            .catch(function (error) {
                setIsLoadingO(false)
                console.error('error saat fetch', error)
                showToast({ type: 'error', message: error.toString() });
            })
    };

    function handleChange() {
        if (props.isDueDate === false) {
            props.getDateNow();
            props.setIsDueDate(true);
        }
        else {
            props.setDueDate('');
            props.setIsDueDate(false);
        }
        setDateFormat(new Date(), props.GetExRate);
    }

    function handleDueDate(value) {
        props.setDueDate(value);
        let dateNow = updateDateFormat(new Date());
        let dateValue = updateDateFormat(value);

        if (dateNow > dateValue) {
            props.GetExRate(dateValue);
        }
    }

    function handleIsDPJob(value) {
        props.setIsDPJob(value);
        props.setJobTypeId(1);
        props.setShipmentOrderList([]);
        props.setShipmentOrderIdList([]);
        props.setSelectedShipmentOrder({});
        props.setBankData([]);
        props.setCashPaymentUSD(0);
        props.setCashPaymentIDR(0);
        props.calculateTotalBank([], value);
        props.calculateTotalCash([]);

        props.setTotalCashUSDReal(0);
        props.setTotalCashIDRReal(0);

        let formatUSD = convertToNominal(0);
        let formatIDR = convertToNominal(0);
        props.setTotalCashUSD(formatUSD);
        props.setTotalCashIDR(formatIDR);
    }

    return (
        <div>
            <form>
                <div>
                    <div>
                        <Grid
                            container
                            spacing={'16px'}
                        >
                            <Grid
                                item
                                xl={3}
                                lg={3}
                                sm={3}
                                xs={12}
                            >
                                <Input
                                    label={'Infoss Number'}
                                    value={props.infossNo}
                                    onChange={(e) => props.setInfossNo(e.target.value)}
                                    formControlProps={{
                                        sx: {
                                            width: '100%',
                                            marginBottom: '16px !important'
                                        }
                                    }}
                                    disabled={props.Printing > 0}
                                    hidden={!isInfossNo}
                                    message={props.infossNo !== '' ? '' : 'This Field is Required'}
                                />
                            </Grid>
                        </Grid>
                        
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Input
                                    label="DP Number"
                                    textAlign='right'
                                    value={props.TRNumber}
                                    disabled
                                    hidden={!props.isEdit}
                                    fullWidth
                                    formControlProps={{
                                        sx: {
                                            width: '100%',
                                        }
                                    }}
                                />

                                <div style={{ marginTop: props.isEdit ? '16px' : '0px' }}>
                                    <Grid
                                        container
                                        spacing={'16px'}
                                    >
                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            sm={6}
                                            xs={12}
                                        >
                                            <div>
                                                {props.selectPrincipleBy}
                                            </div>
                                        </Grid>

                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            sm={6}
                                            xs={12}
                                        >
                                            <div variant='standard' style={{ fullWidth: 'true' }} disabled={props.Printing > 0}>
                                                <Typography
                                                    sx={{
                                                        color: 'var(--Primary-One, #083A50)',
                                                        fontFamily: 'Nunito',
                                                        fontSize: '14px',
                                                        fontStyle: 'normal',
                                                        fontWeight: '600',
                                                        lineHeight: '19.6px',
                                                    }}
                                                >
                                                    Due Date
                                                </Typography>

                                                <Stack direction='row' spacing={'16px'} alignItems={'center'} justifyContent={'center'}>
                                                    <TickBox
                                                        checked={props.isDueDate}
                                                        onChange={() => handleChange()}
                                                        disabled={props.Printing > 0}
                                                    />

                                                    <CustomDatePicker
                                                        type={'date'}
                                                        value={props.DueDate}
                                                        disabled={!props.isDueDate || props.Printing > 0}
                                                        onChange={handleDueDate}
                                                        formControlProps={{
                                                            sx: {
                                                                width: '100%',
                                                                marginTop: '-3px !important'
                                                            }
                                                        }}
                                                    />
                                                </Stack>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>

                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Grid
                                    container
                                    spacing={'16px'}
                                >
                                    <Grid
                                        item
                                        xl={6}
                                        lg={6}
                                        sm={6}
                                        xs={12}
                                    >
                                        <Input
                                            label='Rate'
                                            value={props.Rate}
                                            textAlign='right'
                                            disabled
                                            fullWidth
                                            formControlProps={{
                                                sx: {
                                                    width: '100%',
                                                }
                                            }}
                                        />

                                        <CustomDatePicker
                                            label='Verify Acc'
                                            value={props.verifyAccOn}
                                            type={'date'}
                                            disabled
                                            hidden={!props.isEdit}
                                            formControlProps={{
                                                sx: {
                                                    width: '100%',
                                                    marginTop: '16px !important'
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xl={6}
                                        lg={6}
                                        sm={6}
                                        xs={12}
                                    >
                                        <CustomDatePicker
                                            label='Date Rate'
                                            value={props.RateDate}
                                            type={'date'}
                                            disabled
                                            formControlProps={{
                                                sx: {
                                                    width: '100%',
                                                }
                                            }}
                                        />

                                        <CustomDatePicker
                                            label='Print Date'
                                            value={props.PrintDate}
                                            type={'date'}
                                            disabled
                                            hidden={!props.isEdit}
                                            formControlProps={{
                                                sx: {
                                                    width: '100%',
                                                    marginTop: '16px !important'
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <div style={{ marginTop: '12px' }}>
                                    <Selection
                                        id='0'
                                        label={'Payment By'}
                                        fullWidth={true}
                                        placeholder={'Select Payment By'}
                                        value={props.CustomerTypeId}
                                        onChange={(e) => props.setCustomerTypeId(e.target.value)}
                                        disabled={props.Printing > 0}
                                    >
                                        {
                                            PaymentByData.map((data, index) => (
                                                <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </Selection>
                                </div>

                                <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px !important' }}>
                                    <Input
                                        label='Customer'
                                        value={props.CustomerCode}
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '50%',
                                            }
                                        }}
                                    />

                                    <Input
                                        variant="standard"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={props.CustomerName}
                                        type='text'
                                        label={''}
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                        inputBaseProps={{
                                            sx: {
                                                marginTop: '23px !important',
                                            },
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        disabled={props.isEdit}
                                                        onClick={() => searchCustomer('delete')}
                                                        hidden={!props.isEdit && props.CustomerName ? false : true}
                                                    >
                                                        <Icon
                                                            iconName={'close'}
                                                            svgIconProps={{
                                                                fontSize: 'small',
                                                                htmlColor: '#0087C2',
                                                                sx: {
                                                                    height: '12px',
                                                                    width: '12px'
                                                                }
                                                            }}
                                                        />
                                                    </IconButton>

                                                    <IconButton
                                                        disabled={props.isEdit}
                                                        hidden={props.isEdit}
                                                        onClick={() => searchCustomer('search')}
                                                    >
                                                        <Icon
                                                            iconName={'search'}
                                                            svgIconProps={{
                                                                fontSize: 'small',
                                                                htmlColor: '#0087C2',
                                                                sx: {
                                                                    height: '12px',
                                                                    width: '12px'
                                                                }
                                                            }}
                                                        />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        formLabelProps={{
                                            sx: {
                                                fontFamily: 'Nunito',
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                color: '#083A50 !important',
                                                textAlign: 'left'
                                            }
                                        }}
                                        disabled
                                    />
                                </Stack>
                            </Grid>

                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <div style={{ marginTop: '12px' }}>
                                    <Selection
                                        id='0'
                                        label={'Based On Job'}
                                        fullWidth={true}
                                        placeholder={'Select Based On Job'}
                                        value={props.isDPJob}
                                        onChange={(e) => handleIsDPJob(e.target.value)}
                                        disabled={props.Printing > 0}
                                    >
                                        {
                                            BasedOnJobData.map((data, index) => (
                                                <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </Selection>
                                </div>

                                <Stack spacing={'16px'} direction="row" sx={{ marginTop: '16px' }}>
                                    <Input
                                        label='Receipt Type'
                                        value={props.COACode}
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '50%',
                                            }
                                        }}
                                    />

                                    <Input
                                        variant="standard"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={props.COAName}
                                        type='text'
                                        label={''}
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                        inputBaseProps={{
                                            sx: {
                                                marginTop: '23px !important',
                                            },
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => searchReceiptType('delete')}
                                                        disabled={props.isEdit}
                                                        hidden={!props.isEdit && props.COAName ? false : true}
                                                    >
                                                        <Icon
                                                            iconName={'close'}
                                                            svgIconProps={{
                                                                fontSize: 'small',
                                                                htmlColor: '#0087C2',
                                                                sx: {
                                                                    height: '12px',
                                                                    width: '12px'
                                                                }
                                                            }}
                                                        />
                                                    </IconButton>

                                                    <IconButton
                                                        disabled={props.isEdit}
                                                        hidden={props.isEdit}
                                                        onClick={() => searchReceiptType('search')}
                                                    >
                                                        <Icon
                                                            iconName={'search'}
                                                            svgIconProps={{
                                                                fontSize: 'small',
                                                                htmlColor: '#0087C2',
                                                                sx: {
                                                                    height: '12px',
                                                                    width: '12px'
                                                                }
                                                            }}
                                                        />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        formLabelProps={{
                                            sx: {
                                                fontFamily: 'Nunito',
                                                fontSize: '16px',
                                                fontWeight: '700',
                                                color: '#083A50 !important',
                                                textAlign: 'left'
                                            }
                                        }}
                                        disabled
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </form>

            {
                isModal && (
                    <SelectDataContact
                        isModal={isModal}
                        handleClick={handleClick}
                        titleModal={titleModal}
                        setIsModal={setIsModal}

                        getData={getDataContact}
                        isLoading={isLoadingC}
                        totalRows={totalRowsC}
                        setTotalRows={setTotalRowsC}
                        SelectedData={SelectedDataC}
                        setSelectedData={setSelectedDataC}
                        data={dataC}
                        columnData={columnDataC}
                        dataMap={dataMapC}

                        setCustomerId={props.setCustomerId}
                        setCustomerCode={props.setCustomerCode}
                        setCustomerName={props.setCustomerName}
                        setShipmentOrderList={props.setShipmentOrderList}
                        CustomerTypeId={props.CustomerTypeId}
                        setSelectedShipmentOrder={props.setSelectedShipmentOrder}
                        setBankData={props.setBankData}
                    />
                )
            }

            {
                isModal2 && (
                    <SelectDataCOA
                        isModal={isModal2}
                        handleClick={handleClick2}
                        titleModal={titleModal2}
                        setIsModal={setIsModal2}

                        getData={getDataCOA}
                        isLoading={isLoadingO}
                        totalRows={totalRowsO}
                        setTotalRows={setTotalRowsO}
                        SelectedData={SelectedDataO}
                        setSelectedData={setSelectedDataO}
                        data={dataO}
                        columnData={columnDataO}
                        dataMap={dataMapO}

                        setCOACode={props.setCOACode}
                        setCOAName={props.setCOAName}
                    />
                )
            }
        </div>
    )
}

export default DownPaymentHeader;